<template>
    <div class="panier--popunder">
        <div class="cart--header">
            <div class="cart--header-count">
          <span class="cart-icon">
            <i class="la la-shopping-cart"></i>
          </span>
                <span class="cart--number">{{cartCount}}</span>
            </div>
            <div class="cart--header-total">
                <span class="total-str">{{$t('mobileMenu.total')}}</span>
                <span class="total-amount">{{total | decimalPrice}} €</span>
            </div>
        </div>
        <div class="cart--body" v-if="loading">
            <div class="loader">
                <loader/>
            </div>
        </div>
        <div class="cart--body" v-else-if="cartCount > 0">
          <div class="room-wrapper" v-for="(item, index) in rooms" :index="index" :key="item.id" :item="item">
            <cart-room :item="item"/>
          </div>
        </div>
        <div class="cart--body" v-else>
            <span class="empty">{{$t('mobileMenu.empty')}}</span>
        </div>
        <div class="cart--footer" v-if="cartCount > 0">
            <router-link
                    tag="div"
                    :to="{name: 'step4'}"
                    class="btn btn-primary btn-full btn-std btn-cart">
                {{$t('mobileMenu.order')}}
            </router-link>
        </div>
    </div>
</template>

<script>
    import CartRoom from "./cart-room";
    import Loader from "../loader.component";
    import {mapState} from "vuex";
    export default {
        name: "mobile-cart",
        components: {Loader, CartRoom},
        computed: {
          loading() {
            return this.$store.getters["shoppingCart/loading"];
          },
          cartCount() {
            return this.$store.getters["shoppingCart/cartCount"];
          },
          rooms() {
            return this.$store.getters["shoppingCart/rooms"]
          },
          total() {
            return this.$store.getters["shoppingCart/totalPrice"];
          },
        }
    }
</script>

<style scoped>

    .cart--body {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 1rem;
    }

    .cart--body .room-wrapper {
        transition: all 300ms ease;
        padding: 20px 10px 30px 10px;
        margin: -20px -10px -30px -10px;
        position: relative;
        z-index: 10;
    }

    .cart--body .room-wrapper:hover {
        background: var(--darker-orange);
        box-shadow: 0 0 40px 5px rgba(0, 0, 0, 1);
        z-index: 11;
    }

    .cart--header {
        display: grid;
        grid-template: "1fr 1fr";
        align-items: center;
        padding-bottom: 1rem;
        border-bottom: 1px solid rgba(255, 255, 255, .2);
        margin-bottom: 1rem;
    }

    .cart--footer .btn {
        margin-top: 0 !important;
    }

    .cart--footer {
        padding-top: 1rem;
        border-top: 1px solid rgba(255, 255, 255, .2);
        margin-top: 1rem;
        grid-gap: 1rem;
    }

    .cart--header .cart--header-count {
        display: flex;
        flex-wrap: nowrap;
    }

    .cart--header .cart--header-total {
        text-align: right;
    }

    .cart--header .cart--number {
        flex: 0 0 auto;
        margin: auto auto auto 0;
        background: var(--darker-orange);
        display: inline-block;
        padding: 2px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
    }

    .cart--header .cart--header-total .total-str {
        color: #a2acb2;
    }

    .cart--header .cart--header-total .total-amount {
        color: var(--darker-orange);
        font-weight: 600;
    }

    .cart--header .cart--header-count .cart-icon i {
        font-size: 28px;
    }
    i {
        color: var(--white);
    }

    .loader {
        height: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/components/topbar/mobile-cart.vue